<template>
  <section>
    <Slogn title1="「合作·互助·創新」理念" title2="「共創·共富·共享」目標" sub-title="Join Hands to Create the Future." />
    <div class="content">
      <Title title="Future" class="content-title" />
      <h5> - 理念與目標 - </h5>
      <p class="slogn"> 以 "合作•互助•創新" 為理念；達 "共創•共富•共享"為目標。 </p>
      <p> 以『共富精神理論』作基礎，本社是一個以消費者為中心的消費合作組織，致力於促進共同發展和共識經濟的合作社。</p>
      <p>
        以實際行動及作法，號召有共同理念的消費者與有優質產品的中小型企業及小農與農漁畜牧業大家一齊合作團結，由合作社配合有優質產品的中小型企業及小農與農漁畜牧業生產的產品直接推廣至社員消費，旨在提供社員日常所需的商品和服務。目的是通過共同自覺購買和共享回饋資源，獲得更好的價格、更多的選擇和更高的質量。藉由消費合作社的社員共同出資，共同擁有和管理合作社。通過共同購買來獲得折扣價格回潤，再把利潤空間透過內政部合作社法規定攤還結餘給所有合作社社員，分享合作社的盈餘及回饋，追求共同福祉和經濟民主。
      </p>
    </div>
  </section>
</template>
<script>
import Slogn from '@/components/Slogn'
import Title from '@/components/Title'

export default {
  components: {
    Slogn,
    Title
  }
}
</script>
<style scoped lang="scss">
.content {
  position: relative;
  width: 100%;
  background-color: #e9e9e9;
  padding: 20px 20px;
  margin-top: 48px;
  h5 {
    color: #9e9e9e;
    font-weight: 400;
    margin-bottom: 12px;
  }
  p {
    color: #4c4c4c;
    line-height: 32px;
  }
  p.slogn {
    color: $deepBlue;
    margin-bottom:0;
    @include minWidth992 {
      font-size: 20px;
      margin-bottom:20px;
    }
  }
}
.content-title {
  position: absolute;
  left: 0;
  top: -28px;
  @include minWidth992 {
    top: -40px;
  }
}
</style>
